<div class="auth-modal-container right-label choose-pharmacy">
  <form novalidate
        [formGroup]="selectPharmacyForm"
        (submit)="continue()"
        class="form-container"
  >
    <div class="logo-img"></div>
    <div class="form-header">
      Select pharmacy
    </div>
    <div class="form-description bordered">
      Which pharmacy would you like to sign in to?
    </div>

    <div class="pharmacies-container">
      <app-options-list
        [bordered]="true"
        [secondaryProp]="'address'"
        formControlName="pharmacyId"
        [optionsList]="pharmacies$ | async"
      ></app-options-list>
    </div>

    <app-button customClasses="w-full"
                class="submit-btn"
                [disabled]="selectPharmacyForm.invalid"
                [text]="'Continue'"
                [type]="'submit'"
    ></app-button>
  </form>

  <div class="label-container">
    <div class="label-header login">
      Love <br>
      managing <br>
      your <br>
      controlled substance inventory.
    </div>
  </div>

</div>
